import { mobiClient } from '@/services/axiosConfig'
import { CheckReferralRes, GetNumberListReqV2, GetNumberListResV2, GetPackageInfo, InstanceNewNumberV2, SaveContactInfoReqV2, SaveNumberReqV2, SavePackageInfoReq, SetSignatureReq, TanConfirmReqV2, TanConfirmReqV3, TanConfirmResV2, TanCreateResV2 } from './types'

export const getInstanceV2 = async (id: string, lang: string): Promise<InstanceNewNumberV2 | undefined> => {
  try {
    const res = await mobiClient.get('/newnumberv2/getinfo?instanceId=' + id + '&lang=' + lang)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const createTanV2 = async (email: string): Promise<TanCreateResV2 | undefined> => {
  try {
    const res = await mobiClient.post('/newnumberV2/tancreate', { email })
    return res.data
  } catch (e) {
    console.error(e)
  }
}

export const confirmTanV2 = async (req: TanConfirmReqV2): Promise<TanConfirmResV2 | undefined> => {
  try {
    const res = await mobiClient.post('/newnumberV2/tanconfirm', req)
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}
export const confirmTanNumber = async (req: TanConfirmReqV3): Promise<TanConfirmResV2 | undefined> => {
  try {
    const res = await mobiClient.post('/newnumberV2/tanconfirm', req)
    return res.data
  } catch (e: any) {
    return e.response?.data
  }
}

export const getPackageInfo = async (lang: string, signal: AbortSignal): Promise<GetPackageInfo | undefined> => {
  try {
    const res = await mobiClient.get('/newnumberv2/fullpackageinfo?lang=' + lang, { signal })
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const savePackageInfo = async (req: SavePackageInfoReq, channel: string): Promise<InstanceNewNumberV2 | undefined> => {
  console.log('save package info req:', req)
  try {
    const res = await mobiClient.post('/newnumberv2/savepackageinfo', req, { headers: { channel } })
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const getNumberListV2 = async (req: GetNumberListReqV2): Promise<GetNumberListResV2 | undefined> => {
  try {
    const res = await mobiClient.get('/newnumberv2/numberlist?rateplan=' + (req.rateplan ?? '') + '&pattern=' + (req.pattern ?? '________') + '&page=' + (req.page?.toString() ?? '1'))
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const saveNumberV2 = async (req: SaveNumberReqV2): Promise<InstanceNewNumberV2 | undefined> => {
  try {
    const res = await mobiClient.post('/newnumberv2/savenumber', req)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const saveEsim = async (instanceId: string): Promise<InstanceNewNumberV2 | undefined> => {
  try {
    const res = await mobiClient.post('/newnumberv2/selectesim', { instanceId })
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const saveSelfSim = async (instanceId: string, imsi: string): Promise<InstanceNewNumberV2 | undefined> => {
  try {
    const res = await mobiClient.post('/newnumberv2/selectselfsim', { instanceId, imsi })
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const saveContactV2 = async (req: SaveContactInfoReqV2): Promise<InstanceNewNumberV2 | undefined> => {
  try {
    const res = await mobiClient.post('/newnumberv2/savecontactinfo', req)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const getAgreement = async (instanceId: string): Promise<InstanceNewNumberV2 | undefined> => {
  try {
    const res = await mobiClient.get('/newnumberv2/getagreement?instanceId=' + instanceId)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const doSign = async (req: SetSignatureReq): Promise<InstanceNewNumberV2 | undefined> => {
  console.log('doSign req: ', req)
  try {
    const res = await mobiClient.post('/newnumberv2/dosign', req)
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}

export const checkReferral = async (referralCode: string): Promise<CheckReferralRes | undefined> => {
  try {
    const res = await mobiClient({
      method: 'get',
      headers: {
        'Content-Type': 'application/json'
      },
      url: `/referralpromo/check-refcode?isdn=&referralCode=${referralCode}&promoCode=REFERRAL-PROMO&type&instanceId`
    })
    return res.data
  } catch (e: any) {
    return e.response.data
  }
}
